import{n as a,r as e,y as t}from"../../../493beda6.js";customElements.define("cai-icon-photoshop",class extends a{static get styles(){return e`
      :host {
        display: inline-block;
        width: var(--cai-icon-width, 16px);
        height: var(--cai-icon-height, 16px);
      }

      svg {
        width: 100%;
        height: 100%;
        fill: var(--cai-icon-fill, currentColor);
      }

      path {
      }
    `}render(){return t`<svg
      data-name="app/Ps"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      part="svg"
    >
      <g data-name="Group 2">
        <path
          data-name="Fill 10"
          d="M19.816 24H4.184A4.184 4.184 0 0 1 0 19.816V4.184A4.184 4.184 0 0 1 4.184 0h15.632A4.184 4.184 0 0 1 24 4.184v15.632A4.184 4.184 0 0 1 19.816 24"
          fill="#071e34"
        />
        <path
          data-name="Combined Shape"
          d="M15.332 17.984a5.846 5.846 0 0 1-1.108-.169 4.027 4.027 0 0 1-.743-.269.22.22 0 0 1-.125-.221V15.6c0-.119.049-.152.147-.094a4.513 4.513 0 0 0 1.751.6 3.422 3.422 0 0 0 .968.019A1.239 1.239 0 0 0 16.63 16a.472.472 0 0 0 .063-.8 3.055 3.055 0 0 0-.845-.449 7.317 7.317 0 0 1-.948-.435 4.13 4.13 0 0 1-.847-.6 2.227 2.227 0 0 1-.68-1.411 2.487 2.487 0 0 1 .2-1.261 2.3 2.3 0 0 1 .427-.64 2.743 2.743 0 0 1 1.521-.8 5.573 5.573 0 0 1 1.5-.062 5.528 5.528 0 0 1 .979.144 3.555 3.555 0 0 1 .478.17.128.128 0 0 1 .073.092.554.554 0 0 1 .014.149v1.585c0 .138-.072.187-.193.126a3.868 3.868 0 0 0-.646-.265 4.791 4.791 0 0 0-1.543-.2 1.545 1.545 0 0 0-.475.1.47.47 0 0 0-.182.759 1.466 1.466 0 0 0 .321.247 7.9 7.9 0 0 0 .948.436 5.759 5.759 0 0 1 1.334.729 2.076 2.076 0 0 1 .643.761A2.347 2.347 0 0 1 19 15.471a2.544 2.544 0 0 1-.223 1 2.328 2.328 0 0 1-.66.843 3.138 3.138 0 0 1-1.348.593 4.241 4.241 0 0 1-.923.089 6.746 6.746 0 0 1-.514-.012Zm-10.146-.2c-.164 0-.186-.023-.186-.193V7.169c.008-.087.03-.143.117-.145C5.736 7.012 7.4 7 8.033 7h.239a5.382 5.382 0 0 1 1.818.308 3.271 3.271 0 0 1 1.853 1.575 3.486 3.486 0 0 1 .381 1.328 4.682 4.682 0 0 1-.112 1.557 3.2 3.2 0 0 1-1.061 1.7 3.524 3.524 0 0 1-1.395.7 5.8 5.8 0 0 1-1.179.181 9.154 9.154 0 0 1-.573.016c-.261 0-.527-.008-.783-.016h-.035c-.036 0-.056 0-.066.02a.245.245 0 0 0-.009.1V17.6c0 .139-.041.181-.173.181Zm2.083-5.339h.57a4.008 4.008 0 0 0 .9-.082 2.157 2.157 0 0 0 .926-.4 1.384 1.384 0 0 0 .466-.642 2.164 2.164 0 0 0 .083-.9 1.443 1.443 0 0 0-.662-1.101 2.23 2.23 0 0 0-1.164-.332c-.121 0-.245-.006-.37-.006-.265 0-.539.009-.837.027-.057 0-.072.021-.072.08v3.176a.492.492 0 0 1 0 .05c-.005.043-.011.088.015.113a.1.1 0 0 0 .067.017h.077Z"
          fill="#54a7f7"
        />
      </g>
    </svg>`}});
